import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { Loading } from '/imports/ui/Loading';

type LoadingFullScreenProps = {
  caption?: string
};

const LoadingFullScreenStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  z-index: 1000;
  background-color: ${css.backgroundColor};
`;

/**
 * Full-screen overlay showing a loading spinner with an optional caption.
 */
export const LoadingFullScreen = (props: LoadingFullScreenProps = {}) => (
  <LoadingFullScreenStyled className="loading-fullscreen">
    <Loading caption={props.caption} />
  </LoadingFullScreenStyled>
);